import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Jsonsmkyu9xjl7fv as Json } from '../../../../../kotlinx-serialization-kotlinx-serialization-json/kotlinx/serialization/json/Json.mjs';
import { Properties3rdc3388jbgie as Properties } from '../../../../../kotlinx-serialization-kotlinx-serialization-properties/kotlinx/serialization/properties/Properties.mjs';
import { UriFormat1t8mwnpxf0d72 as UriFormat } from '../../../../../kotlinx-serialization-uri/com/lightningkite/kotlinx/serialization/uri/UriFormat.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_DefaultSerializersModule() {
  _init_properties_serialization_kt__ogvo82();
  return DefaultSerializersModule;
}
var DefaultSerializersModule;
function get_DefaultJsonCurrent() {
  _init_properties_serialization_kt__ogvo82();
  return DefaultJsonCurrent;
}
var DefaultJsonCurrent;
var UrlPropertiesCurrent;
function get_DefaultUriFormatCurrent() {
  _init_properties_serialization_kt__ogvo82();
  return DefaultUriFormatCurrent;
}
var DefaultUriFormatCurrent;
function get_DefaultJson() {
  _init_properties_serialization_kt__ogvo82();
  return get_DefaultJsonCurrent();
}
function get_DefaultUriFormat() {
  _init_properties_serialization_kt__ogvo82();
  return get_DefaultUriFormatCurrent();
}
function DefaultJsonCurrent$lambda($this$Json) {
  _init_properties_serialization_kt__ogvo82();
  $this$Json.serializersModule_1 = get_DefaultSerializersModule();
  $this$Json.ignoreUnknownKeys_1 = true;
  return Unit_instance;
}
var properties_initialized_serialization_kt_jcw1mo;
function _init_properties_serialization_kt__ogvo82() {
  if (!properties_initialized_serialization_kt_jcw1mo) {
    properties_initialized_serialization_kt_jcw1mo = true;
    DefaultSerializersModule = EmptySerializersModule();
    DefaultJsonCurrent = Json(VOID, DefaultJsonCurrent$lambda);
    UrlPropertiesCurrent = Properties(get_DefaultSerializersModule());
    DefaultUriFormatCurrent = new (UriFormat())(get_DefaultSerializersModule());
  }
}
//region block: exports
export {
  get_DefaultJson as get_DefaultJson7vbyrb403mrj,
  get_DefaultSerializersModule as get_DefaultSerializersModule10h5j26es502p,
  get_DefaultUriFormat as get_DefaultUriFormat2bqsbberx5mh8,
};
//endregion

//# sourceMappingURL=serialization.mjs.map
